import { render, staticRenderFns } from "./stock-adjustment-review.vue?vue&type=template&id=b4fb607e"
import script from "./stock-adjustment-review.vue?vue&type=script&lang=js"
export * from "./stock-adjustment-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports